import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const PremiumGames = ({ flag }) => {
    const [games, setGames] = useState([]);
    const [loading, setLoading] = useState(true);
    const [imageLoadState, setImageLoadState] = useState({}); // Track loaded images

    useEffect(() => {
        axios
            .get(`https://feeds.gamepix.com/v2/json?sid=G2A5E&order=pubdate&pagination=${flag}&page=1`)
            .then((response) => {
                setGames(response.data.items);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching games:", error);
                setLoading(false);
            });
    }, [flag]);

    const handleImageLoad = (gameId) => {
        setImageLoadState((prev) => ({ ...prev, [gameId]: true }));
    };

    if (loading) return <p className="text-center text-white">Loading games...</p>;

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
            {games.map((game) => (
                <div key={game.id || game.title} className="bg-[#ffff] dark:bg-black rounded-[10px] overflow-hidden mt-3 cursor-pointer 
                        shadow-sm hover:drop-shadow-[0_6px_15px_rgba(255,255,255,0.7)] transition-shadow duration-300 ease-in-out">
                    <Link to={`/games?${game.url}&name=${game.title}`}>
                        <div className="overflow-hidden w-full">
                            {!imageLoadState[game.id] && (
                                <div className="bg-gray-300 w-full h-[110px] sm:h-[123px] md:h-[153px] lg:h-[100px] xl:h-[128px] 2xl:h-[158px] animate-wave-skeleton"></div>
                            )}
                            <img
                                src={game.banner_image}
                                alt={game.title}
                                className={`w-full h-full rounded-x-2xl transition ease-out duration-700 ${!imageLoadState[game.id] ? "blur" : ""}`}
                                style={{ filter: imageLoadState[game.id] ? "none" : "blur(20px)" }}
                                onLoad={() => handleImageLoad(game.id)}
                            />
                        </div>
                        <div className="p-2">
                            <p className="text-[10px] md:text-sm leading-none font-bold text-center truncate dark:text-white">
                                {game.title}
                            </p>
                        </div>
                    </Link>
                </div>
            ))}
        </div>
    );
};

export default PremiumGames;
